import { fetchApi } from '@/app/api';
import { Project } from '@certhon/models';

export interface ProjectsQuery {
  archived?: boolean;
}

export function fetchProjects(qry?: ProjectsQuery) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return fetchApi('/projects', qry as any);
}

export function fetchProject(projectId: number) {
  return fetchApi(`/projects/${projectId}` as '/projects/:recnum');
}

// fixme: proper PATCH body type
export function patchProject(
  recnum: number,
  updates: Partial<Project & { associate: number; dissociate: number }>,
): Promise<Project> {
  return fetchApi(`/projects/${recnum}` as '/projects/:recnum', undefined, {
    method: 'PATCH',
    body: JSON.stringify(updates),
  });
}
